import { Catalog } from "../../catalog/Catalog";
import React from "react";

export const CatalogStep = () => {
    return (
        <>
            <div className={"configurator-info container"}>
                <h1>Schritt 1: Wählen Sie Ihr Modell.</h1>
                <p>
                    Der perfekte Sessel oder Stuhl wird nicht allein durch die Funktion und die Wahl der Werkstoffe
                    bestimmt. Oft steht auch das Visuelle im Vordergrund.
                </p>
            </div>
            <section className={"catalog-section container"}>
                <Catalog heading={"Unsere Produkte"} configuratorUrl={""} />
            </section>
        </>
    );
};
